import { ItemDataModel } from './ItemDataModel';

export abstract class SessionBase {
    constructor(readonly sessionId: string) {

    }
    abstract getItemData(itemId: string): ItemDataModel;
}